<template>
  <v-container>
    <v-row>
      <v-col cols="3">
        <v-btn :loading="studentSyncLoading" @click="syncStudents"> Sync Students </v-btn>
      </v-col>
      <v-col cols="4">
        <v-alert v-for="(alert, index ) in alerts" :key="index"
          dismissible
          :type="alert.type"
          >
          {{ alert.message }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row class="mt-10">
    </v-row>
  </v-container>
</template>

<script>
const api = require('../apiFunctions.js')
const fb = require('../firebaseConfig.js')
const moment = require('moment')

function sanitize(s) {
  return s.replace(/[^a-z]/gi, '');
}

export default {

  data: () => ({
    user: fb.session.user,
    alerts: []
  }),
  mounted () {
  },
  methods: {
    syncStudents: function () {
      var self = this
      self.studentSyncLoading = true
      self.alerts = []
      api.get('syncSkedulaStudents', {}, (data) => {
        self.studentSyncLoading = false
        console.log(data)
        self.alerts.push({
          type: 'success',
          message: 'added ' + data.newStudents.length + ' students'
        })
      })
    }
  }
}
</script>
